import {
    GET_CALLS,
    GET_CALLS_SUCCESS,
    GET_CALLS_ERROR,
    GET_CALL_TRANSCRIPTION,
    GET_CALL_TRANSCRIPTION_SUCCESS,
    GET_CALL_TRANSCRIPTION_ERROR,
    GET_CALL_TRANSCRIPTION_SETTINGS,
    GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
    GET_CALL_TRANSCRIPTION_SETTINGS_ERROR,
    UPDATE_CALL_TRANSCRIPTION_SETTINGS,
    UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
    UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR,
    GET_CALL_TRANSCRIPTION_TOPICS,
    GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS,
    GET_CALL_TRANSCRIPTION_TOPICS_ERROR,
    CREATE_CALL_TRANSCRIPTION_TOPIC,
    CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
    CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
    UPDATE_CALL_TRANSCRIPTION_TOPIC,
    UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
    UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
    DELETE_CALL_TRANSCRIPTION_TOPIC,
    DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
    DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR,
    UPDATE_CALL,
    UPDATE_CALL_SUCCESS,
    UPDATE_CALL_ERROR,
  } from "./actionTypes"
  
  export const getCalls = payload => {
    return {
      type: GET_CALLS,
      payload: payload,
    }
  }
  
  export const getCallsSuccess = (calls, meta = {}) => {
    return {
      type: GET_CALLS_SUCCESS,
      payload: calls,
      meta,
    }
  }
  
  export const getCallsError = error => {
    return {
      type: GET_CALLS_ERROR,
      payload: error,
    }
  }

  export const updateCall = payload => {
    return {
      type: UPDATE_CALL,
      payload: payload,
    }
  }

  export const updateCallSuccess = call => {
    return {
      type: UPDATE_CALL_SUCCESS,
      payload: call,
    }
  }

  export const updateCallError = error => {
    return {
      type: UPDATE_CALL_ERROR,
      payload: error,
    }
  }

  export const getCallTranscription = payload => {
    return {
      type: GET_CALL_TRANSCRIPTION,
      payload: payload,
    }
  }

  export const getCallTranscriptionSuccess = call_transcriptions => {
    return {
      type: GET_CALL_TRANSCRIPTION_SUCCESS,
      payload: call_transcriptions,
    }
  }

  export const getCallTranscriptionError = error => {
    return {
      type: GET_CALL_TRANSCRIPTION_ERROR,
      payload: error,
    }
  }

  export const getCallTranscriptionSettings = payload => {
    return {
      type: GET_CALL_TRANSCRIPTION_SETTINGS,
      payload: payload,
    }
  }

  export const getCallTranscriptionSettingsSuccess = call_transcription_settings => {
    return {
      type: GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
      payload: call_transcription_settings,
    }
  }

  export const getCallTranscriptionSettingsError = error => {
    return {
      type: GET_CALL_TRANSCRIPTION_SETTINGS_ERROR,
      payload: error,
    }
  }

  export const updateCallTranscriptionSettings = payload => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_SETTINGS,
      payload: payload,
    }
  }

  export const updateCallTranscriptionSettingsSuccess = call_transcription_settings => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS,
      payload: call_transcription_settings,
    }
  }

  export const updateCallTranscriptionSettingsError = error => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR,
      payload: error,
    }
  }

  export const getCallTranscriptionTopics = payload => {
    return {
      type: GET_CALL_TRANSCRIPTION_TOPICS,
      payload: payload,
    }
  }

  export const getCallTranscriptionTopicsSuccess = call_transcription_topics => {
    return {
      type: GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS,
      payload: call_transcription_topics,
    }
  }

  export const getCallTranscriptionTopicsError = error => {
    return {
      type: GET_CALL_TRANSCRIPTION_TOPICS_ERROR,
      payload: error,
    }
  }

  export const createCallTranscriptionTopic = payload => {
    return {
      type: CREATE_CALL_TRANSCRIPTION_TOPIC,
      payload: payload,
    }
  }

  export const createCallTranscriptionTopicSuccess = call_transcription_topic => {
    return {
      type: CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
      payload: call_transcription_topic,
    }
  }

  export const createCallTranscriptionTopicError = error => {
    return {
      type: CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
      payload: error,
    }
  }

  export const updateCallTranscriptionTopic = payload => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_TOPIC,
      payload: payload,
    }
  }

  export const updateCallTranscriptionTopicSuccess = call_transcription_topic => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
      payload: call_transcription_topic,
    }
  }

  export const updateCallTranscriptionTopicError = error => {
    return {
      type: UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR,
      payload: error,
    }
  }

  export const deleteCallTranscriptionTopic = payload => {
    return {
      type: DELETE_CALL_TRANSCRIPTION_TOPIC,
      payload: payload,
    }
  }

  export const deleteCallTranscriptionTopicSuccess = call_transcription_topic => {
    return {
      type: DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS,
      payload: call_transcription_topic,
    }
  }

  export const deleteCallTranscriptionTopicError = error => {
    return {
      type: DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR,
      payload: error,
    }
  }




  